import React from 'react';
import noop from 'lodash/noop';

import { CheckMark } from '@lyearn/icons';
import { Checkbox, Stack } from '@lyearn/ui';
import CollectionItem from '@/modules/corporate/modules/group/views/GroupManager/components/CollectionsDialog/CollectionItem';
import { ContentCollectionGroupType } from '@/types/schema';

function CollectionSelector({
  collection,
  isSelected,
  toggle,
  isAlreadySelected,
  multiSelect,
}: {
  collection: ContentCollectionGroupType;
  isSelected: boolean;
  toggle: (collectionId: string) => void;
  multiSelect?: boolean;
  isAlreadySelected?: boolean;
}) {
  return (
    <Stack
      alignItems="center"
      className="flex-shrink-0 cursor-pointer border-b border-solid border-border py-16 ps-16 pe-20"
      justifyContent="between"
      onClick={() => (isAlreadySelected ? noop : toggle(collection.id))} // flex-shrink-0: safari fix - ui collapsing in some safari versions
    >
      <CollectionItem group={collection} />
      {multiSelect ? (
        <Checkbox
          checked={isSelected || isAlreadySelected}
          data-attr="SELECT"
          data-id={collection.id}
          disabled={isAlreadySelected}
        />
      ) : null}
      {!multiSelect && isSelected ? <CheckMark className="h-24 w-24" /> : null}
    </Stack>
  );
}

export default CollectionSelector;
